export const GET_CAREER_QUIZ_TAGS = 'GET_CAREER_QUIZ_TAGS';
export const GET_CAREER_QUIZ_TAG_BY_ID = 'GET_CAREER_QUIZ_TAG_BY_ID';
export const UPDATE_CAREER_QUIZ_TAG = 'UPDATE_CAREER_QUIZ_TAG';
export const DELETE_CAREER_QUIZ_TAG = 'DELETE_CAREER_QUIZ_TAG';
export const CREATE_CAREER_QUIZ_TAG = 'CREATE_CAREER_QUIZ_TAG';
